<template>
<v-text-field class="edn_mail_beta" ref="edn_mail_beta" @click:append="goTo" :readonly="disabled" :filled="disabled" :append-icon="linkmode && rulesPattern.test(text) ? $attrs['append-icon'] ? $attrs['append-icon'] : 'mdi-email' : ''" v-model="text" :rules="required ? [oRules.required, oRules.email] : [oRules.email]">
    <template v-slot:label>
        {{$attrs.label}} <span v-if="required" class="red--text">*</span>
    </template>
</v-text-field>
</template>

<script>
export default {
    components: {},
    props: {
        requiredMessage: {
            type: String,
            default: () => 'Vous devez entrer une valeur.',
        },
        rulesMessage: {
            type: String,
            default: () => 'Vous devez entrer une adresse mail valide.',
        },
        required: {
            type: Boolean,
            default: () => false,
        },
        rulesPattern: {
            type: RegExp,
            default: () => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        },
        disabled: {
            type: Boolean,
            default: () => false,
        },
        linkmode: {
            type: Boolean,
            default: () => false,
        },

    },
    data() {
        return {
            marker: true,
            text: '',
            oRules: {
                required: value => !!value || this.requiredMessage,
                email: value => {
                    const pattern = this.rulesPattern
                    return pattern.test(value) || this.rulesMessage
                },
            },
        }
    },
    inheritAttrs: false,
    methods: {
        goTo() {
            window.location.href = "mailto:" + this.text;
        },
    },
}
</script>

<style lang="scss">
.edn_mail_beta.v-input--is-readonly .v-input__append-inner{
  pointer-events: auto;
}
div {
    &.v-input {
        &.v-text-field {
            &.linkIris {
                div {
                    &.v-input__slot {
                        :after {
                            border: none;
                        }
                    }
                }

                input {
                    text-decoration: underline;
                    color: #1ca6fd;
                    cursor: pointer;
                }
            }
        }
    }
}
</style>
